module.exports = __webpack_public_path__ + "img/api.0e594639.jpg";